import { db, auth } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

export const trackClick = async (actionName, extraData = {}) => {
  try {
    const user = auth.currentUser;

    await addDoc(collection(db, "Click_Tracking"), {
      action: actionName,               // e.g. "Share Button Click"
      page: window.location.pathname,   // where user clicked
      userId: user?.uid || null,
      email: user?.email || null,
      timestamp: serverTimestamp(),
      ...extraData                       // anything extra you want
    });
  } catch (error) {
    console.error("Click tracking failed:", error);
  }
};
